import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { OfferPositionResponseDTO } from '../../../../type/dto/RequestResponseDTO';
import { OfferPositionImages } from './OfferPositionImages';

interface OfferPositionItemProps {
    position: OfferPositionResponseDTO;
    index: number;
    onImageClick: (imageUrl: string) => void;
}

export const OfferPositionItem: FC<OfferPositionItemProps> = ({
    position,
    index,
    onImageClick
}) => {
    return (
        <Box sx={{ pl: 2, borderLeft: '2px solid', borderLeftColor: 'divider' }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {index + 1}. {position.productName}
            </Typography>

            {position.brand && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                    Brand: {position.brand}
                </Typography>
            )}

            <Box sx={{ display: 'flex', gap: 2, mt: 0.5, flexWrap: 'wrap' }}>
                <Typography variant="body2">
                    Price: <strong>${position.price}</strong>
                </Typography>
                <Typography variant="body2">
                    Qty: <strong>{position.quantity}</strong>
                </Typography>
                {position.deliveryTime && (
                    <Typography variant="body2">
                        Delivery: <strong>{position.deliveryTime}</strong>
                    </Typography>
                )}
            </Box>

            {position.description && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                    {position.description}
                </Typography>
            )}

            <OfferPositionImages
                images={position.images}
                productName={position.productName}
                onImageClick={onImageClick}
            />
        </Box>
    );
};

